import React, {useEffect, useRef, useState} from "react";
import {
    Table,
    DefaultTablePagination,
    DatePicker,
    InputBox,
} from "../../components/Elements/appUtils";
import PageHeader from "../../components/Elements/pageHeader";
import moment from "moment";
import {fetchAllOrder} from "../order/actions";
import {userListFxn} from "../userManager/actions";
import {tableListFxn} from "../pos/actions";

function ComplimentaryBillList() {
    const tableRef = useRef();

    const [activeTab, setActiveTab] = useState("today");
    const [dates, setDates] = useState({
        fromDate: "",
        toDate: "",
    });

    const [tableFilterData, setTableFilterData] = useState([]);
    const [tableName, setTableName] = useState("");
    const [tableList, setTableList] = useState([]);
    const [userName, setUserName] = useState("");
    const [userList, setUsers] = useState([]);

    const handleDateTab = (key) => {
        setActiveTab(key);

        const today = new Date();
        let from, to;

        switch (key) {
            case "today":
                from = to = today;
                break;
            case "7days":
                from = new Date();
                from.setDate(today.getDate() - 7);
                to = today;
                break;
            case "1month":
                from = new Date();
                from.setMonth(today.getMonth() - 1);
                to = today;
                break;
            case "3months":
                from = new Date();
                from.setMonth(today.getMonth() - 3);
                to = today;
                break;
            case "custom":
                from = "";
                to = "";
                break;
            default:
                from = to = today;
        }

        setDates({fromDate: from, toDate: to});
    };

    useEffect(() => {
        if (tableName) {
            const table = tableList.find((item) => item.name === tableName);

            if (table) {
                const keysArray = table.tables.map((item) => item.key);
                setTableFilterData(keysArray);
            } else {
                setTableFilterData([]);
            }
        } else {
            setTableFilterData([]);
        }
    }, [tableName, tableList]);

    const loadTables = async () => {
        const {data} = await tableListFxn();
        const filteredData = (data || []).filter(
            (item) =>
                item.name.toLowerCase() !== "hod" &&
                item.name.toLowerCase() !== "md" &&
                item.name.toLowerCase() !== "guest"
        );
        setTableList(filteredData);
    };

    const loadUsers = async (params = {}) => {
        params.results = 200;
        const {data} = await userListFxn({...params});
        setUsers(data || []);
    };

    useEffect(() => {
        loadTables();
        loadUsers();
    }, []);

    const apiRequest = (params) => {
        return new Promise(async (resolve) => {
            try {
                if (dates.fromDate && dates.toDate) {
                    params.dayOpenDate = {
                        $gte: moment(dates.fromDate).startOf("day")._d,
                        $lte: moment(dates.toDate).endOf("day")._d,
                    };
                }

                params.isComplementaryBill = true;
                params.status = { $in: ["Paid"] };
                // params.guest = false;

                if (tableFilterData.length > 0) {
                    params.tableNo = tableFilterData;
                }

                if (userName) {
                    params.userId = userName;
                }

                const data = await fetchAllOrder({...params});
                console.log("COMPLEMENTARY LIST RESPONSE =>", data);
                resolve(data);
            } catch (error) {
                console.error("Error fetching complimentary bill list:", error);
            }
        });
    };

    const refreshTable = () => {
        tableRef.current.reload();
    };

    const columns = [
        {
            title: "Sr. No",
            dataIndex: "serialNo",
            key: "serialNo",
            width: 90,
            render: (text, record, index) => index + 1,
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            width: 130,
            render: () => (
                <label className={"label label-warning label-style"}>
                    Complimentary
                </label>
            ),
        },
        {
            title: "Table No.",
            dataIndex: "tableNo",
            key: "tableNo",
        },
        // {
        //     title: "Order No.",
        //     dataIndex: "orderNo",
        //     key: "orderNo",
        //     render: (item, record) => record.complementaryOrderNo || item || "-",
        // },
        {
            title: "Table Name",
            dataIndex: "tableName",
            key: "tableName",
            render: (item) => item || "-",
        },
        {
            title: "Day Open Date",
            dataIndex: "dayOpenDate",
            key: "dayOpenDate",
            render: (text, record) => (
                <span>{text && moment(record.dayOpenDate).format("DD/MM/YYYY")}</span>
            ),
        },
        {
            title: "Order Date & Time",
            dataIndex: "date",
            key: "date",
            render: (text, record) => (
                <span>{moment(record.date).format("DD/MM/YYYY, hh:mm A")}</span>
            ),
        },
        {
            title: "Customer Name",
            dataIndex: "customerName",
            key: "customerName",
            render: (item) => item || "-",
        },
        {
            title: "Pax Number",
            dataIndex: "paxNumber",
            key: "paxNumber",
            render: (item) => item || "-",
        },
        {
            title: "Total Amount",
            dataIndex: "totalAmount",
            key: "totalAmount",
        },
        {
            title: "Discount",
            dataIndex: "discount",
            key: "discount",
        },
        {
            title: "CGST Amount",
            dataIndex: "cgstAmount",
            key: "cgstAmount",
        },
        {
            title: "SGST Amount",
            dataIndex: "sgstAmount",
            key: "sgstAmount",
        },
        {
            title: "Service Charges",
            dataIndex: "serviceTaxAmount",
            key: "serviceTaxAmount",
        },
        {
            title: "Net Amount",
            dataIndex: "netAmount",
            key: "netAmount",
        },
        {
            title: "Reason",
            dataIndex: "complementaryReason",
            key: "complementaryReason",
            render: (item) => item || "-",
        },
        {
            title: "Added By User",
            dataIndex: "userName",
            key: "userName",
            render: (item) => item || "-",
        },
    ];

    return (
        <PageHeader title={"Complimentary Bills"}>
            <div className="row mb-3">
                <div className="col-md-12 mb-3">
                    <div className="btn-group">
                        {[
                            {key: "today", label: "Today"},
                            {key: "7days", label: "Last 7 Days"},
                            {key: "1month", label: "Last Month"},
                            {key: "3months", label: "Last 3 Months"},
                            {key: "custom", label: "Custom"},
                        ].map((tab) => (
                            <button
                                key={tab.key}
                                className={`btn btn-outline-primary ${
                                    activeTab === tab.key ? "activeDuration" : ""
                                }`}
                                onClick={() => handleDateTab(tab.key)}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>
                </div>

                {activeTab === "custom" && (
                    <>
                        <div className="col-md-2">
                            <InputBox title={"From Date"}>
                                <DatePicker
                                    value={dates.fromDate}
                                    showClear={true}
                                    placeholder={"Choose from Date"}
                                    onChange={(value) =>
                                        setDates({...dates, fromDate: value})
                                    }
                                />
                            </InputBox>
                        </div>

                        <div className="col-md-2">
                            <InputBox title={"To Date"}>
                                <DatePicker
                                    value={dates.toDate}
                                    showClear={true}
                                    placeholder={"Choose to Date"}
                                    onChange={(value) =>
                                        setDates({...dates, toDate: value})
                                    }
                                />
                            </InputBox>
                        </div>
                    </>
                )}

                <div className="col-md-2">
                    <InputBox title={"Choose Venue"}>
                        <select
                            className="form-control search-filters"
                            onChange={(e) => setTableName(e.target.value)}
                            value={tableName}
                        >
                            <option value={""}>Choose Venue</option>
                            {tableList.map((item) => (
                                <option key={item.name} value={item.name}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </InputBox>
                </div>

                <div className="col-md-2">
                    <InputBox title={"Choose User"}>
                        <select
                            className="form-control search-filters"
                            onChange={(e) => setUserName(e.target.value)}
                            value={userName}
                        >
                            <option value={""}>Choose User</option>
                            {userList.map((item) => (
                                <option key={item._id} value={item._id}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </InputBox>
                </div>

                <div className="col-md-1 mt-4">
                    <div className="search-wrap">
                        <button className="btn btn-info" onClick={refreshTable}>
                            Search
                        </button>
                    </div>
                </div>
            </div>

            <div className="card mb-0">
                <div className="table-responsive" style={{overflow: "auto"}}>
                    <Table
                        apiRequest={apiRequest}
                        columns={columns}
                        pagination={DefaultTablePagination()}
                        ref={tableRef}
                        scroll={{x: 2200}}
                    />
                </div>
            </div>
        </PageHeader>
    );
}

export default ComplimentaryBillList;